import React from "react";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { LinkedinCertification } from "linkedin-certification";
import { useParams } from 'react-router-dom'

import Certificate from './certificate';
import { certificateData } from '../api';
import constants from "../constants";

class App extends React.Component{

    state = { certificateData: {}, id: null, year: new Date().getFullYear() }

    async componentDidMount(){
        try{
            window.scrollTo(0,0);
            let id = this.props.params.id;
            await this.setState({ id });
            if(id){
                let response = await certificateData(id);
                if(response.data.status === "success"){
                    await this.setState({ certificateData: response.data['data'] });
                }else{
                    this.setState({ certificateData: null })
                }
            }else{
                this.setState({ certificateData: null })
            }
        }catch(err){
            console.log(err.message);
            this.setState({ certificateData: null })
        }
    }

    _exportPdf = () => {
        const input = document.getElementById('certificate');
        html2canvas(input, {
            scale: 2
        })
        .then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF({
                orientation: "landscape",
            });
            let width = pdf.internal.pageSize.getWidth();
            let height = pdf.internal.pageSize.getHeight();
            console.log(input.offsetWidth, input.offsetHeight)
            pdf.addImage(imgData, 'JPEG', 0, 0, width, height);
            // pdf.output('/');
            pdf.save(`download.pdf`);
        })
    }

    renderValidCertificate(){
        let data = this.state.certificateData;
        if(data){
            return (
                <React.Fragment>
                    <Certificate data={data} />
                    <div className="certificate__act" >
                        <button className="certificate__act--download" onClick={this._exportPdf} >
                            <img src="/assets/certificate/download.png" alt="" />
                            Download Certificate
                        </button>
                        <LinkedinCertification
                            certificationName={data['course'] + ' Certification Program'}
                            organizationName="Business Toys"
                            issuedMonth={new Date(data['issuedOn']).getMonth() + 1}
                            issuedYear={new Date(data['issuedOn']).getFullYear()}
                            certificateId={this.state.id}
                            certificateURL={constants.certificateURL + `${this.state.id}`}
                            newTab={true}
                            customButton={
                                <button className="button is-link">
                                  <img src="/assets/certificate/linkedin.png" alt="" />
                                  <span>Add to LinkedIn</span>
                                </button>
                              }
                        />
                        <p>Open in Laptop or Desktop to view & download</p>
                    </div>
                </React.Fragment>
                )
        }else{
            return null;
        }
    }

    render(){
        return(
            <section className="certificate" >
                <div className="certificate__nav" >
                    <a href="https://businesstoys.in" target="__blank" >
                        <img 
                            src="https://businesstoys.in/assets/global/business-toys-main.png" 
                            alt="business toys logo" />
                    </a>
                </div>
                {
                this.state.certificateData ?
                <h1>
                    Business Toys Skills School acknowledges the following accomplishment
                </h1>
                :
                <h1 className="certificate">
                    Invalid Certificate Id
                </h1>}
                { this.renderValidCertificate() } 
                <p className="certificate--c">Copyright &#169; Business Toys {this.state.year} </p>
            </section>
        )
    }
};

function AppRouter(props){
    let params = useParams();
    return <App params={params} {...props} />
}

export default AppRouter;